import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/icons/more.svg'
import _imports_1 from '../../assets/svgs/edit.svg'
import _imports_2 from '../../assets/svgs/action_plus.svg'
import _imports_3 from '../../assets/svgs/talent.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "dots"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "absolute border-gray-100 right-0 top-auto mt-1 rounded-xl shadow-2xl text-sm overflow-hidden w-64 z-20"
}
const _hoisted_4 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_5 = { class: "flex flex-col mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Edit")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "text-gray-200"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "Add to a job")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "text-gray-200"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold ml-4" }, "View global candidate")
], -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen)),
      type: "button",
      class: "select-none p-3 hover:bg-gray-100 rounded-lg"
    }, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isMenuOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openEdit && _ctx.openEdit(...args))),
                    class: "rounded p-4 hover:bg-background"
                  }, _hoisted_7),
                  (!_ctx.companyCandidate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.assignJob && _ctx.assignJob(...args))),
                        class: "rounded p-4 hover:bg-background"
                      }, _hoisted_9))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToGlobalCandidate && _ctx.goToGlobalCandidate(...args))),
                        class: "rounded p-4 hover:bg-background"
                      }, _hoisted_11))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_directive_click_away, _ctx.closeMenu]
  ])
}